import _defaultTo from "lodash/fp/defaultTo";
import _pipe from "lodash/fp/pipe";
import _get from "lodash/fp/get";
import { useThemeUI } from 'theme-ui';
export var themeProp = function themeProp(str) {
  return function (props) {
    return _get("theme." + str, props);
  };
};

if (typeof themeProp !== 'undefined' && themeProp && themeProp === Object(themeProp) && Object.isExtensible(themeProp) && !themeProp.hasOwnProperty('__filemeta')) {
  Object.defineProperty(themeProp, '__filemeta', {
    configurable: true,
    value: {
      name: "themeProp",
      filename: "node_modules/gatsby-theme-docz/src/utils/theme.js"
    }
  });
}

export var usePrismTheme = function usePrismTheme() {
  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme,
      colorMode = _useThemeUI.colorMode;

  var getTheme = _pipe(_get('prismTheme'), _defaultTo(_get("prism." + colorMode, theme)));

  return getTheme(theme);
};

if (typeof usePrismTheme !== 'undefined' && usePrismTheme && usePrismTheme === Object(usePrismTheme) && Object.isExtensible(usePrismTheme) && !usePrismTheme.hasOwnProperty('__filemeta')) {
  Object.defineProperty(usePrismTheme, '__filemeta', {
    configurable: true,
    value: {
      name: "usePrismTheme",
      filename: "node_modules/gatsby-theme-docz/src/utils/theme.js"
    }
  });
}